<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div
  fxLayoutAlign="space-between center"
  class="nvc-width-hundred sc-header-icon nvc-top-zero"
  *ngIf="
    !isMobileDevice() &&
    !(dialogData.standardTemplate && headerEnabled) &&
    !summaryData &&
    !slotService.websitePromolinkCB
  "
>
  <img
    class="nvc-image-style"
    [ngClass]="{
      'ws-cursor-pointer': this.router.url.includes('promolink') && !ARDialog
    }"
    [src]="logoSource"
    (click)="
      slotService.websitePromolinkCB
        ? returnToLandingPage()
        : this.slotService.onLogoClicked.next(true)
    "
    alt="shopconnect"
  />
  <div
    fxFlex="10"
    fxFlex.sm="13"
    (click)="redirectNavHeaders('bookings')"
    class="ws-cursor-pointer responsive-font-size"
    *ngIf="isAppointment"
  >
    <b>My Bookings</b>
  </div>
  <div
    id="myOrders"
    fxFlex="10"
    fxFlex.sm="13"
    (click)="redirectNavHeaders('orders')"
    class="ws-cursor-pointer responsive-font-size"
    *ngIf="isCheckoutEnabled"
  >
    <b>My Orders</b>
  </div>
  <div
    id="myOrders"
    fxFlex="10"
    fxFlex.sm="13"
    (click)="redirectNavHeaders('address')"
    class="ws-cursor-pointer responsive-font-size"
    *ngIf="!isRetailer() && loggedIn() && isCheckoutEnabled"
  >
    <b>My Addresses</b>
  </div>
  <h4 class="nvc-font-weight-normal">
    {{ userDetails && userDetails.name ? userDetails.name : "" }}
  </h4>
</div>

<div
  fxLayoutAlign="space-between center"
  class="nvc-width-hundred nvc-position-absolute nvc-overlay-1"
  *ngIf="
    (dialogData.standardTemplate && headerEnabled && !summaryData) ||
    (slotService.websitePromolinkCB && !isMobileDevice())
  "
  [ngClass]="{
    'sc-custom-height sc-header-enabled':
      slotService.websitePromolinkCB && !isMobileDevice(),
    'sc-z-index-4': isMobileDevice()
  }"
>
  <app-cart-header
    class="nvc-width-hundred"
    *ngIf="
      (dialogData?.standardTemplate && headerEnabled && !summaryData) ||
      slotService.websitePromolinkCB
    "
    [data]="dialogData?.data"
    [cartLength]="cartLength"
    [fromSummary]="true"
    (changePassword)="changePassword()"
    (goToMyProfile)="promoLinkAuthorizationService.goToMyProfile()"
    (menuActions)="menuActions($event)"
    (logOut)="logOut()"
    (shareLink)="shareLink()"
    (openCart)="openCart()"
    (onPreviewClick)="onPreviewClick($event)"
    (openWishlist)="menuActions('wishlist')"
    (redirectToLandingPage)="returnToLandingPage()"
  >
  </app-cart-header>
</div>

<div
  [fxLayoutAlign]="
    (dialogData?.standardTemplate && headerEnabled) ||
    slotService.websitePromolinkCB
      ? 'start center'
      : 'end center'
  "
  class="nvc-width-hundred nvc-positions sc-header-icon-mobile"
  [ngClass]="{ 'sc-header-custom-height': slotService.websitePromolinkCB }"
  *ngIf="isMobileDevice()"
>
  <img
    [class]="
      (dialogData?.standardTemplate && headerEnabled) ||
      slotService.websitePromolinkCB
        ? 'sc-company-logo'
        : 'sc-height-30px'
    "
    [src]="logoSource"
    (click)="
      slotService.websitePromolinkCB
        ? returnToLandingPage()
        : this.slotService.onLogoClicked.next(true)
    "
    alt="shopconnect"
  />
  <app-cart-header
    class="nvc-width-hundred"
    *ngIf="
      (dialogData?.standardTemplate && headerEnabled && !summaryData) ||
      slotService.websitePromolinkCB
    "
    [data]="dialogData?.data"
    [cartLength]="cartLength"
    [fromSummary]="true"
    (changePassword)="changePassword()"
    (goToMyProfile)="promoLinkAuthorizationService.goToMyProfile()"
    (menuActions)="menuActions($event)"
    (logOut)="logOut()"
    (shareLink)="shareLink()"
    (openCart)="openCart()"
    (onPreviewClick)="onPreviewClick($event)"
    (openWishlist)="menuActions('wishlist')"
    (redirectToLandingPage)="returnToLandingPage()"
  >
  </app-cart-header>
</div>

<div
  fxLayoutAlign="center center"
  class="nvc-width-hundred"
  *ngIf="dialogData"
  [ngClass]="
    isMobileDevice()
      ? slotService.websitePromolinkCB
        ? 'sc-container-mobile sc-content-margin'
        : 'sc-container-mobile'
      : dialogData?.isVideoCall
      ? 'sc-container-video'
      : (dialogData?.standardTemplate && headerEnabled) ||
        slotService.websitePromolinkCB
      ? 'sc-margin-header'
      : 'sc-container'
  "
>
  <div
    fxLayout="column"
    fxLayoutAlign="center center"
    class="nvc-width-hundred"
  >
    <div fxLayoutAlign="center center">
      <img
        class="sc-order-placed-logo sc-height-30px"
        [ngClass]="isMobileDevice() ? 'sc-order-placed-logo-mobile' : ''"
        [src]="orderIcon"
        alt="order placed"
      />
    </div>
    <div
      fxLayoutAlign="center center"
      class="sc-order-placed-header"
      [ngClass]="isMobileDevice() ? 'sc-order-placed-header-mobile' : ''"
    >
      <span>{{ statusHeader }}</span>
    </div>
    <div
      class="sc-order-placed-text"
      fxLayoutAlign="center center"
      [ngClass]="isMobileDevice() ? 'sc-order-placed-text-mobile' : ''"
    >
      <span>{{ statusSubheader }}</span>
      <!-- <span *ngIf="!summaryData"
        >Your order placed successfully, order no:
        {{ orderId ? orderId : "-" }} .</span
      > -->
    </div>
    <div
      fxLayoutAlign="center center"
      class="sc-order-placed-text"
      [ngClass]="isMobileDevice() ? 'sc-order-placed-text-mobile' : ''"
    >
      {{ statusDescription }}
    </div>
    <div fxLayout="row" fxLayoutAlign="center center">
      <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="center center">
        <button
          class="sc-view-detailes-button ws-cursor-pointer sc-margin-24px"
          [ngClass]="
            isMobileDevice() ? 'sc-margin-12px sc-margin-right-zero' : ''
          "
          (click)="close()"
          *ngIf="status === 'Fail'"
        >
          {{
            this.dialogData?.isVideoCall
              ? "BACK TO VIDEO CALL"
              : "CONTINUE SHOPPING"
          }}
        </button>
        <button
          class="sc-view-detailes-button ws-cursor-pointer sc-margin-24px"
          [ngClass]="
            isMobileDevice() ? 'sc-margin-12px sc-margin-right-zero' : ''
          "
          (click)="
            slotService.websitePromolinkCB
              ? menuActions('myorders')
              : paymentOrderId
              ? openOrders()
              : openMyOrders()
          "
        >
          <!-- {{ summaryData ? "MY ORDERS" : paymentOrderId ? "GO TO ORDERS" : "VIEW ORDER" }} -->
          MY ORDERS
        </button>
        <button
          class="sc-continue-button ws-cursor-pointer sc-margin-24px"
          [ngClass]="isMobileDevice() ? 'sc-margin-12px' : ''"
          (click)="close(status === 'Fail')"
        >
          {{
            status === "Fail"
              ? "RETRY PAYMENT"
              : this.dialogData?.isVideoCall
              ? "BACK TO VIDEO CALL"
              : "CONTINUE SHOPPING"
          }}
        </button>
      </div>
    </div>
    <div
      *ngIf="!isSubscriber && !isMobileDevice()"
      fxLayout="row"
      fxLayoutAlign="start center"
      class="sc-border-5"
      [ngClass]="isTabDevice() ? 'sc-subscribe-box-tab' : 'sc-subscribe-box'"
    >
      <div class="sc-subscribe sc-line-height sc-margin-2">
        <div class="sc-subscribe-text">Subscribe</div>
        to our newsletter
        <button
          class="sc-subscribe-button sc-margin-24px"
          (click)="!subscriberUpdated ? subscribeNow() : ''"
          [ngClass]="!subscriberUpdated ? 'ws-cursor-pointer' : ''"
        >
          {{ subscriberUpdated ? "Subscribed" : "Subscribe Now" }}
        </button>
      </div>
      <div class="nvc-icon sc-news-image">
        <img
          class="nvc-summary nvc-width-hundred"
          src="assets/images/newsletter.svg"
          alt=""
        />
      </div>
    </div>
    <div
      *ngIf="!isSubscriber && isMobileDevice()"
      fxLayout="column"
      fxLayoutAlign="start"
      class="sc-subscribe-box-mobile sc-border-5"
    >
      <div class="nvc-width-hundred">
        <span class="sc-subscribe-text-mobile sc-line-height sc-margin-2"
          >Subscribe</span
        ><br />
        <span class="sc-font-size-14 sc-margin-2">to our newsletter</span>
      </div>
      <div class="nvc-icon">
        <img
          class="nvc-width-hundred nvc-height-hundred"
          src="assets/images/newsletter.svg"
          alt=""
        />
      </div>
      <div>
        <button
          class="sc-subscribe-button ws-cursor-pointer sc-margin-24px sc-subscribe-button-mobile"
          (click)="!subscriberUpdated ? subscribeNow() : ''"
        >
          {{ subscriberUpdated ? "Subscribed" : "Subscribe Now" }}
        </button>
      </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="center center">
      <div
        fxLayout="column"
        class="sc-powered-by"
        fxLayoutAlign="center center"
        [ngClass]="isSubscriber ? 'sc-margin-top-5' : ''"
      >
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          class="nvc-powered-font-weight ws-cursor-pointer"
          (click)="slotService.redirectPoweredBy()"
        >
          <p>Powered By&nbsp;</p>
          <img
            class="nvc-image-style-footer"
            alt="shopconnect"
            src="assets/icons/powered-Color-new.png"
          />
        </div>
      </div>
    </div>
  </div>
</div>
<app-order-link-footer
  id="footerCBCart"
  *ngIf="
    (dialogData?.standardTemplate && footerEnabled && !summaryData) ||
    slotService.websitePromolinkCB
  "
></app-order-link-footer>
